export default "__VITE_ASSET__BwdE1QfQ__"